function isObject(val: any): val is {} {
  return typeof val === 'object' && !Array.isArray(val);
}

export default isObject;
